import React, { useState } from 'react';

const MemberCreditComponent = () => {
  const [employeeId, setEmployeeId] = useState('');
  const [mobile, setMobile] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [balanceSheetData, setBalanceSheetData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // Sample balance sheet data
  const sampleBalanceSheet = [
    { id: 1, date: '01-12-2024', mobile: '9044750234', transaction: 'Credit', amount: 500, employeeId: 'EMP123' },
    { id: 2, date: '02-12-2024', mobile: '8840530382', transaction: 'Debit', amount: 100, employeeId: 'EMP124' },
    { id: 3, date: '03-12-2024', mobile: '9855300087', transaction: 'Credit', amount: 120, employeeId: 'EMP123' },
    { id: 4, date: '04-12-2024', mobile: '7366016111', transaction: 'Credit', amount: 200, employeeId: 'EMP125' },
    // Additional data can be added here...
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    // Apply filtering logic based on form inputs
    const filtered = sampleBalanceSheet.filter((record) => {
      const isMobileMatch = mobile ? record.mobile === mobile : true;
      const isEmployeeMatch = employeeId ? record.employeeId === employeeId : true;
      const isFromDateMatch = fromDate ? new Date(record.date) >= new Date(fromDate) : true;
      const isToDateMatch = toDate ? new Date(record.date) <= new Date(toDate) : true;

      return isMobileMatch && isEmployeeMatch && isFromDateMatch && isToDateMatch;
    });

    setFilteredData(filtered);
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    margin: '0 auto',
    fontSize: '14px', // smaller font size
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
    width: '200px',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
    fontSize: '12px', // smaller font size for labels
  };

  const inputStyle = {
    padding: '6px', // reduced padding for smaller input field
    fontSize: '12px', // smaller font size for input fields
    borderRadius: '4px',
    border: '1px solid #ccc',
  };

  const buttonStyle = {
    padding: '8px 16px', // reduced padding for a smaller button
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px', // smaller font size for the button
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    fontSize: '12px', // smaller font size for table
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px', // smaller padding for table cells
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', fontSize: '18px' }}>Member Balance Sheet</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Employee Id</label>
            <input
              type="text"
              style={inputStyle}
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              placeholder="Enter Employee Id"
            />
          </div>

          <div style={formGroupStyle}>
            <label style={labelStyle}>Enter Mobile</label>
            <input
              type="text"
              style={inputStyle}
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter Mobile"
            />
          </div>

          <div style={formGroupStyle}>
            <label style={labelStyle}>From Date</label>
            <input
              type="date"
              style={inputStyle}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div style={formGroupStyle}>
            <label style={labelStyle}>To Date</label>
            <input
              type="date"
              style={inputStyle}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </div>
      </form>

      {/* Displaying the Balance Sheet Data */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Transaction</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Amount</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Employee Id</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((record) => (
              <tr key={record.id}>
                <td style={thTdStyle}>{record.id}</td>
                <td style={thTdStyle}>{record.date}</td>
                <td style={thTdStyle}>{record.mobile}</td>
                <td style={thTdStyle}>{record.transaction}</td>
                <td style={thTdStyle}>{record.amount}</td>
                <td style={thTdStyle}>{record.employeeId}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={thTdStyle}>No data found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MemberCreditComponent;
